// extracted by mini-css-extract-plugin
module.exports = {"title":"AboutTitle_title__ITMkP","about__title":"AboutTitle_about__title__1DGaD","about__blob":"AboutTitle_about__blob__3PzFz"};